import { render, staticRenderFns } from "./LocalisationReference.vue?vue&type=template&id=0fd281dc"
import script from "./LocalisationReference.vue?vue&type=script&lang=js"
export * from "./LocalisationReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports